import { CloseIcon, ExpandIcon, FullscreenIcon, ShrinkIcon } from "./icons";

export type Status = "idle" | "live" | "listening" | "thinking";
export type Size = "normal" | "wide" | "full";

const LABEL: Record<Status, string> = { idle: "Ready", live: "Live", listening: "Listening", thinking: "Thinking" };
const CLASS: Record<Status, string> = { idle: "", live: "live", listening: "listen", thinking: "think" };

interface Props {
  name: string;
  status: Status;
  secondsLeft: number | undefined;
  size: Size;
  /** Inline embeds can widen; popup panels can't. */
  canWiden: boolean;
  /** Sheets/panels get a close (minimise) button; the full-screen toggle is hidden there. */
  onClose?: (() => void) | undefined;
  onSize: (s: Size) => void;
}

export function Header({ name, status, secondsLeft, size, canWiden, onClose, onSize }: Props) {
  return (
    <div class="wk-head">
      <span class="wk-brand"><i aria-hidden="true" /><span>{name}</span></span>
      <span class={`wk-pill ${CLASS[status]}`} role="status"><span class="dot" aria-hidden="true" /><span class="label">{LABEL[status]}</span></span>
      {secondsLeft !== undefined && <span class={`wk-timer${secondsLeft <= 60 ? " warn" : ""}`} aria-label="Time left">{fmt(secondsLeft)}</span>}
      <span class="wk-actions">
        {canWiden && size !== "full" && (
          <button class="wk-hb" onClick={() => onSize(size === "wide" ? "normal" : "wide")} aria-label={size === "wide" ? "Shrink" : "Expand"} title={size === "wide" ? "Shrink" : "Expand"}>
            {size === "wide" ? <ShrinkIcon /> : <ExpandIcon />}
          </button>
        )}
        {!onClose && (
          <button class="wk-hb" onClick={() => onSize(size === "full" ? "normal" : "full")} aria-label={size === "full" ? "Exit full screen" : "Full screen"} title={size === "full" ? "Exit full screen" : "Full screen"}>
            {size === "full" ? <ShrinkIcon /> : <FullscreenIcon />}
          </button>
        )}
        {onClose && (
          <button class="wk-hb" onClick={onClose} aria-label="Minimise assistant" title="Minimise">
            <CloseIcon />
          </button>
        )}
      </span>
    </div>
  );
}

function fmt(s: number): string {
  return `${Math.floor(s / 60)}:${(s % 60).toString().padStart(2, "0")}`;
}
